<ng-container *ngIf="vm$ | async as vm">
  <section
    class="row"
    *ngFor="
      let pageItemsToDisplay of pageItemsWithEmailBlocker$ | async;
      let index = index;
      trackBy: trackbyFn;
      let first = first;
      let last = last
    "
    [class.page-item-first]="first && firstItemTopMargin$ | async"
    #pageItem
  >
    <!-- SIMPLE ELEMENT CONTENTS -->
    <ng-container
      *ngIf="pageItemsToDisplay.type === PageItemToDisplayType.Simple; else emailBlockerContainer"
      [ngTemplateOutlet]="pageItemTemplates"
      [ngTemplateOutletContext]="{ $implicit: pageItemsToDisplay.pageItem, extraClass: 'col' }"
    ></ng-container>

    <!-- EMAIL BLOCKER CONTENTS -->
    <ng-template #emailBlockerContainer>
      <div class="email-blocker-container col">
        <!-- The two page items, that needs to go under the email blocker -> absolute positioned -->
        <div class="email-blocker-underlay-items">
          <ng-container
            *ngFor="let pageItem of pageItemsToDisplay.items; trackBy: trackbyFn"
            [ngTemplateOutlet]="pageItemTemplates"
            [ngTemplateOutletContext]="{ $implicit: pageItem }"
          ></ng-container>
        </div>
        <osn-shared-marketing-email-blocker
          class="email-blocker"
          [vm]="pageItemsToDisplay.emailBlockerItem"
          [minHeight]="pageItemsToDisplay.minHeight"
        ></osn-shared-marketing-email-blocker>
      </div>
    </ng-template>

    <!-- TEMPLATE TO RENDER PAGE ITEMS (except email blocker, as it is handled separately above) -->
    <ng-template #pageItemTemplates let-pageItem let-extraClass="extraClass">
      <div [osnSharedIntersectionMarker] [attr.data-index]="index" class="intersection-boundary" style="height: 1px; width: 100%"></div>
      <div [ngClass]="extraClass" [ngSwitch]="pageItem?.type">
        <osn-shared-continue-watching-carousel
          *ngSwitchCase="'ContinueWatchingCarousel'"
          [vm]="pageItem"
          (carouselItemSelect)="onCarouselItemSelect($event)"
          (carouselItemImpression)="onCarouselItemImpression($event)"
        ></osn-shared-continue-watching-carousel>
        <osn-shared-my-list-carousel
          *ngSwitchCase="'MyListCarousel'"
          [vm]="pageItem"
          (carouselItemSelect)="onCarouselItemSelect($event)"
          (carouselItemImpression)="onCarouselItemImpression($event)"
        ></osn-shared-my-list-carousel>
        <osn-shared-basic-carousel
          data-testid="HomePage.basicCarousels"
          *ngSwitchCase="'BasicCarousel'"
          [vm]="pageItem"
          [showSeoTitle]="vm.shouldShowSeoTitle"
          (carouselItemSelect)="onCarouselItemSelect($event)"
          (carouselItemImpression)="onCarouselItemImpression($event)"
        ></osn-shared-basic-carousel>
        <osn-shared-top-carousel
          *ngSwitchCase="'TopCarousel'"
          data-testid="HomePage.topCarousel"
          [vm]="pageItem"
          [showSeoTitle]="vm.shouldShowSeoTitle"
          (carouselItemSelect)="onCarouselItemSelect($event)"
          (carouselItemImpression)="onCarouselItemImpression($event)"
        ></osn-shared-top-carousel>
        <osn-shared-collection-carousel
          *ngSwitchCase="'CollectionCarousel'"
          [vm]="pageItem"
          [showSeoTitle]="vm.shouldShowSeoTitle"
          (carouselItemSelect)="onCarouselItemSelect($event)"
          (carouselItemImpression)="onCarouselItemImpression($event)"
        ></osn-shared-collection-carousel>
        <osn-shared-season-collection-carousel
          *ngSwitchCase="'SeasonCollectionCarousel'"
          [vm]="pageItem"
          [showSeoTitle]="vm.shouldShowSeoTitle"
          (carouselItemSelect)="onCarouselItemSelect($event)"
          (carouselItemImpression)="onCarouselItemImpression($event)"
        ></osn-shared-season-collection-carousel>
        <osn-shared-season-basic-carousel
          *ngSwitchCase="'SeasonBasicCarousel'"
          [vm]="pageItem"
          [showSeoTitle]="vm.shouldShowSeoTitle"
          (carouselItemSelect)="onCarouselItemSelect($event)"
          (carouselItemImpression)="onCarouselItemImpression($event)"
        ></osn-shared-season-basic-carousel>
        <osn-shared-recommendation-carousel
          *ngSwitchCase="'RecommendationCarousel'"
          [vm]="pageItem"
          (carouselItemSelect)="onCarouselItemSelect($event)"
          (carouselItemImpression)="onCarouselItemImpression($event)"
        ></osn-shared-recommendation-carousel>
        <osn-shared-generic-carousel
          *ngSwitchCase="'GenericCarousel'"
          [vm]="pageItem"
          [showSeoTitle]="vm.shouldShowSeoTitle"
        ></osn-shared-generic-carousel>
        <osn-shared-hero
          *ngSwitchCase="'Hero'"
          data-testid="HomePage.heroItem"
          [vm]="pageItem"
          (heroItemButtonClick)="onHeroItemButtonClick($event)"
          (heroItemChangeByTheUser)="onHeroItemNavigationByTheUser($event)"
          (heroItemGenreClick)="onHeroItemGenreClick($event)"
        ></osn-shared-hero>
        <osn-shared-marketing-cta [vm]="pageItem" *ngSwitchCase="'MarketingCta'"></osn-shared-marketing-cta>
        <osn-shared-marketing-email-collector
          (emailSubmitted)="onEmailSubmitted($event)"
          [asyncEmailValidator]="asyncPrimaryCredentialValidator"
          [vm]="pageItem"
          *ngSwitchCase="'MarketingEmailCollector'"
        ></osn-shared-marketing-email-collector>
        <div class="container-fluid" *ngSwitchCase="'MarketingDevice'">
          <osn-shared-device-module
            [vm]="pageItem"
            (marketingDeviceModuleButtonClick)="onMarketingDeviceModuleButtonClick()"
          ></osn-shared-device-module>
        </div>
        <osn-shared-marketing-multiple-content-title-banner
          [vm]="pageItem"
          *ngSwitchCase="'MarketingMultipleContentTitleBanner'"
        ></osn-shared-marketing-multiple-content-title-banner>
        <osn-shared-marketing-kids [vm]="pageItem" *ngSwitchCase="'MarketingKids'"></osn-shared-marketing-kids>
        <osn-shared-marketing-usp [vm]="pageItem" *ngSwitchCase="'MarketingUsp'"></osn-shared-marketing-usp>
        <osn-shared-marketing-studio [vm]="pageItem" *ngSwitchCase="'MarketingStudio'"></osn-shared-marketing-studio>
        <osn-shared-marketing-hero [vm]="pageItem" *ngSwitchCase="'MarketingHero'"></osn-shared-marketing-hero>
        <osn-shared-marketing-trending [vm]="pageItem" *ngSwitchCase="'MarketingTrending'"></osn-shared-marketing-trending>
        <osn-shared-faq [vm]="pageItem" *ngSwitchCase="'Faq'"></osn-shared-faq>
        <osn-shared-spotlight-tray *ngSwitchCase="'SpotlightViewModel'" [vm]="pageItem"></osn-shared-spotlight-tray>
      </div>
    </ng-template>
  </section>
</ng-container>
